import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-arrow-right-green.png'


const _withScopeId = n => (_pushScopeId("data-v-56a10499"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "more-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"1.85rem"}
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "my-points-wrapper"
}
const _hoisted_5 = { class: "current-points-wrapper" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "sub-title" }
const _hoisted_9 = { class: "text-wrapper" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "charity-list-box"
}
const _hoisted_12 = {
  key: 1,
  class: "history-wrapper row"
}
const _hoisted_13 = { class: "item-card" }
const _hoisted_14 = ["src", "onClick"]
const _hoisted_15 = { class: "content" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "sub-text-wrapper" }
const _hoisted_18 = { class: "primary" }
const _hoisted_19 = { class: "pagination-box" }

import { computed, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { NavbarType } from '@/types/navbar';
  import { useRoute } from 'vue-router';
  import { authStore, Collection, settingStore } from '@/stores';
  import { request } from '@/utils';
  import { REDEMPTION_STATE } from '@/constants';
  import { Redemption, getPdoDefaultRedemption } from '@/types/redemption';
  import Charity from '@/views/points/components/charity.vue';
  import { ICharity } from '@/types/charity';

  interface StoreType extends Collection {
    data: Redemption[]
  }

  interface CharityStoreType extends Collection {
    data: ICharity[]
  }
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();

  const navbar: NavbarType[] = [
    { name: t('Redeem my points'), key: 'points' },
    { name: t('Redeem history'), key: 'history' },
  ];

  const type = computed(() => {
    return {
      points: 'points',
      history: 'history',
    }[route.query.type as string] || navbar[0].key;
  });

  const pointUsage = computed(() => {
    const companyAccount = authStore.user.company_account;
    if (!companyAccount || companyAccount.role !== 'store_sub') {
      return true;
    }
    return authStore.user.point_usage;
  });

  const store = Collection.create<StoreType>({
    params: {
      per_page: 9
    },
    data: [getPdoDefaultRedemption()],
    fetch(params = {}) {
      return request.get('/redemption_records', { params });
    }
  });

  const charityStore = Collection.create<CharityStoreType>({
    params: { page: 0, action_type: 'favor', target_type: 'Charity' },
    async fetch(params = {}) {
      const res = await request.get('/action_stores', { params });
      res.data.forEach((item: ICharity) => {
        item.favored = true;
      });
      return res;
    }
  });

  function handlePageChange(page: any) {
    store.fetchData({ page });
  }

  function handlePrizeJump(prize: Redemption['prize']) {
    if (!prize.partner_url) {
      return;
    }
    window.open(prize.partner_url);
  }

  function handleCharitySubmited() {
    authStore.fetchData();
  }

  function charityUpdateFavored(data: ICharity) {
    charityStore.removeItemById(data.id);
  }

  onMounted(() => {
    settingStore.tryFetchData();
    if (type.value === 'history') {
      store.fetchData();
    } else {
      authStore.fetchData();
      charityStore.fetchData();
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_AppNavbar = _resolveComponent("AppNavbar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppPagination = _resolveComponent("AppPagination")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AppNavbar, { navbar: navbar }),
      (_unref(type) === navbar[0].key && _unref(pointUsage))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "d-flex align-items-center text-decoration-none",
            to: { name: 'points' }
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('more')), 1),
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_unref(type) === navbar[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('Your current have:')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("strong", null, _toDisplayString(_unref(authStore).user.points), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('points')), 1)
            ])
          ]),
          (_unref(pointUsage))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('Favorite charities')), 1),
                _createElementVNode("div", _hoisted_9, [
                  (!_unref(charityStore).data.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)('texts.0')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_router_link, { to: { name: 'points' } }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('texts.1')), 1)
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_unref(charityStore).data.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(Charity, {
                  list: _unref(charityStore).data,
                  points: _unref(authStore).user.points,
                  "point-usage": _unref(pointUsage),
                  "min-donate-points": _unref(settingStore).data.min_donate_points,
                  onSubmited: handleCharitySubmited,
                  onUpdateFavored: charityUpdateFavored
                }, null, 8, ["list", "points", "point-usage", "min-donate-points"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(type) === navbar[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_unref(store).isFulfilled && _unref(store).data.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["state", [item.state]])
                      }, _toDisplayString(_unref(REDEMPTION_STATE)[item.state]), 3),
                      (item.prize.images && item.prize.images.length)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.prize.images[0].url,
                            class: "image",
                            onClick: ($event: any) => (handlePrizeJump(item.prize))
                          }, null, 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: "text-overflow-2 title",
                          onClick: ($event: any) => (handlePrizeJump(item.prize))
                        }, _toDisplayString(item.prize.name), 9, _hoisted_16),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("strong", _hoisted_18, _toDisplayString(item.prize.point_cost), 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('points')), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_AppPagination, {
                    total: _unref(store).meta.total,
                    "per-page": _unref(store).meta.per_page,
                    page: _unref(store).meta.page,
                    onChange: handlePageChange
                  }, null, 8, ["total", "per-page", "page"])
                ])
              ], 64))
            : (_openBlock(), _createBlock(_component_AppEmptyView, { key: 1 }))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})